if (!customElements.get("media-gallery")) {
	customElements.define(
		"media-gallery",
		class MediaGallery extends HTMLElement {
			initSliders() {
				if (this.mainSlider) return

				const mainSliderElement = this.querySelector(`#splide-${this.dataset.sectionId}`)
				if (!mainSliderElement) return

				this.mainSlider = new Splide(mainSliderElement, {
					type: "slide",
					rewind: true,
					perPage: 1,
					gap: "1rem",
					arrows: true,
					pagination: true,
					destroy: true,
					breakpoints: {
						840: {
							destroy: false
						}
					}
				})
				this.mainSlider.mount()
			}

			connectedCallback() {
				this.initSliders()
			}
		}
	)
}
